import NBT from "./NBT";

export default NBT;
